var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"checklist-album-list-item__img",attrs:{"src":_vm.url,"alt":"photo2"}})
}
var staticRenderFns = []

export { render, staticRenderFns }